var exports = {
  "kL": "MobileBottomNav.module__container___Z0ZlNl",
  "oi": "MobileBottomNav.module__navButton___Z0ZlNl",
  "Mv": "MobileBottomNav.module__navButtonActive___Z0ZlNl",
  "XA": "MobileBottomNav.module__navButtonInactive___Z0ZlNl",
  "VK": "MobileBottomNav.module__voiceButton___Z0ZlNl",
  "Kk": "MobileBottomNav.module__icon___Z0ZlNl",
  "Pf": "MobileBottomNav.module__label___Z0ZlNl",
};

module.exports = exports;
